export enum Role {
  Assistant = "assistant",
  User = "user",
  System = "system"
}
